/* Sound toggle for the Social videos section; playback stays with social-videos.js. */
(function () {
  if (customElements.get('xali-social-video-sound')) return;

  customElements.define(
    'xali-social-video-sound',
    class extends HTMLElement {
      connectedCallback() {
        this.item = this.closest('[data-social-video-item]');
        this.video = this.item && this.item.querySelector('video');
        this.button = this.querySelector('[data-video-mute]');
        if (!this.video || !this.button) return;

        this.onClick = this.onClick.bind(this);
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onVolumeChange = this.onVolumeChange.bind(this);

        this.button.addEventListener('click', this.onClick);
        this.button.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.video.addEventListener('volumechange', this.onVolumeChange);
        this.onVolumeChange();
      }

      // The item's own touchstart toggles playback; keep a tap on this button out of it.
      onTouchStart(event) {
        event.stopPropagation();
      }

      onClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.video.muted = !this.video.muted;

        if (!this.video.muted && this.video.paused) {
          const play = this.item.querySelector('[data-video-play]');
          if (play) play.click();
        }
      }

      onVolumeChange() {
        this.item.toggleAttribute('data-video-muted', this.video.muted);
        const key = this.video.muted ? 'labelUnmute' : 'labelMute';
        this.button.setAttribute('aria-label', this.button.dataset[key] || '');
      }

      disconnectedCallback() {
        if (!this.video || !this.button) return;
        this.button.removeEventListener('click', this.onClick);
        this.button.removeEventListener('touchstart', this.onTouchStart);
        this.video.removeEventListener('volumechange', this.onVolumeChange);
      }
    }
  );
})();
